import { render, staticRenderFns } from "./changeCardApp.vue?vue&type=template&id=4765f31c&scoped=true&"
import script from "./changeCardApp.vue?vue&type=script&lang=js&"
export * from "./changeCardApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765f31c",
  null
  
)

export default component.exports